import getTranslatedText from '../../_flux/helper/get_translated_text';
import { getAbsoluteValueForLoadIndex } from './get_absolute_value_for_load_index';

function addLoadIndexAbsoluteValueToLabel(loadIndex) {
    return getTranslatedText('load-index-absolute-value-hint', {
        LOAD_INDEX: loadIndex,
        ABSOLUTE_VALUE: getAbsoluteValueForLoadIndex(loadIndex)
    });
}

export { addLoadIndexAbsoluteValueToLabel };